const SidebarScroll = () => {
    const sidebarElement = document.getElementById('simple-sidebar-notification');
    if (sidebarElement) {
        sidebarElement.scrollIntoView({behavior: "smooth", block: "start", inline: "nearest"});
    }
};

export default SidebarScroll;